import { createPostMessageChannel, safeParsePostMessage } from "./postMessageHelpers";

// Send a message and wait for a reply
export async function getUserId() {
  const response = await createPostMessageChannel(
    parent,
    "*",
    {
      "MessageId": "Request_User_Id",
      "SendTime": Date.now(),
      "Values": {},
      "Origin": location.origin,
    },
    (msg) => {
      return msg.MessageId === 'Request_User_Id_Response';
    },
    {
      maxRetries: 6
    },
  );
  console.log(response);
  return response?.Success ? response.Values : {};
}

export function getPathUserId(presentationId) {
  try {
    const decodedPath = atob(presentationId);
    const userId = decodedPath.split(/[\\/]/)[0];
    return userId;
  } catch (error) {
    console.error("Error processing Base64 path:", error);
    return null;
  }
}

export function getItemId(presentationId) {
  try {
    const decodedPath = atob(presentationId);
    const fileName = decodedPath.split(/[\\/]/).pop();
    // Remove '_poll.pptx' suffix if present
    const baseName = fileName.replace(/_poll\.pptx$/i, "");
    return baseName;
  } catch (error) {
    console.error("Error processing Base64 path:", error);
    return null;
  }
}
